import { useTranslation } from "react-i18next";
import { EsfStationMCore, EsfStationSizes } from "./esfStationCore";
import { colors, fonts, glyphs } from "../../../Styles";
import NewButton from "../../BaseComponents/newButton";

interface EsfStationModelProps {
  currentlyAnimal?: number
  previouslyAnimal?: number
  components?: boolean
  onClick?: () => void
}

  export function EsfStationEnhanced({currentlyAnimal, previouslyAnimal, components, onClick}:EsfStationModelProps) {
  const { t } = useTranslation();
  
  return (
    <div style={{position: "relative", width: "fit-content", height: "fit-content"}}>
      <EsfStationMCore size={EsfStationSizes.normal} pins={{components: components}} />
      <div style={{position: "absolute", top: "62%", left: "55%", transform: "translate(-50%, -50%)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "5px"}}>
        <NewButton
          content={`${t("esfWalkThroughPages.sections.inThisStation", {defaultValue: "in this station"})}`}
          subContent={`${t("animalPages.animal.animal", {defaultValue: "Animal"})} ${currentlyAnimal ?? "not detected"}`}
          startEnhancer={glyphs.Animal({ fillColor: colors.greyLightTertiary, size: "40px" })}
          overrides={{
            baseStyles: { backgroundColor: colors.graphBlueSeven, width: "fit-content" },
            hoverStyles: { backgroundColor: colors.graphBlueEight },
            contentStyles: {textAlign: "left"},
            subContentStyles: {...fonts.fontSize3, ...fonts.header, color: colors.greyLightTertiary, textAlign: "left"},
          }}
          onClick={onClick}
        />
        <div style={{display: "flex", alignItems: "center", justifyContent: "center", gap: "5px"}}>
          <p style={{ ...fonts.fontSize3, ...fonts.header, color: colors.graphBlueSeven }}>{`${t("esfWalkThroughPages.sections.previously", {defaultValue: "previously"})}`}</p>
          <p style={{ ...fonts.fontSize3, ...fonts.header, color: colors.greyLightTertiary }}>{`${t("animalPages.animal.animal", {defaultValue: "Animal"})} ${previouslyAnimal ?? "no animal"}`}</p>
          </div>
      </div>
    </div>
  )
}